import React, { useState } from "react";
import { AppBar, Toolbar, Link, Box, IconButton, Button, Drawer, List, ListItem, ListItemText, Typography, useTheme, Dialog, DialogTitle, DialogContent, DialogActions } from "@mui/material";
import { Menu as MenuIcon } from "@mui/icons-material";
import Contact from "./Contact";
import Login from "./Login.js";

const Header = ({ toggleTheme, isDarkMode, handleLoginToggle }) => {
  const theme = useTheme();
  const [mobileOpen, setMobileOpen] = useState(false);
  const [videoOpen, setVideoOpen] = useState(false);
  const [contactOpen, setContactOpen] = useState(false);
  const [signInOpen, setSignInOpen] = useState(false);

  const handleDrawerToggle = () => setMobileOpen(!mobileOpen);
  const handleVideoOpen = () => setVideoOpen(true);
  const handleVideoClose = () => setVideoOpen(false);

  return (
    <>
      <AppBar position="sticky" sx={{ backgroundColor: theme.palette.primary.main }}>
        <Toolbar>
          {/* Mobile Menu Button */}
          <IconButton edge="start" color="inherit" aria-label="menu" onClick={handleDrawerToggle} sx={{ display: { xs: "block", md: "none" } }}>
            <MenuIcon />
          </IconButton>

          {/* Desktop Logo */}
          <Box sx={{ flexGrow: 1, textAlign: { xs: "center", md: "left" } }}>
            <img
              src="/rocket-white.png" // Make sure this file is in the public folder
              alt="Rocket Offer Logo"
              style={{ height: 40 }}
            />
          </Box>

          {/* Desktop Navigation Buttons */}
          <Box sx={{ display: { xs: "none", md: "flex" }, alignItems: "center" }}>
            <Button
              variant="contained"
              color="secondary"
              sx={{
                ml: 2,
                fontWeight: 'bold',
                borderRadius: '20px',
                backgroundColor: '#ffffff', // warm accent tone like orange or gold
                color: 'black',
                '&:hover': {
                  backgroundColor: '#fb8c00',
                },
              }}
              component={Link}
              to="/open-house"
            >
              Open House Entry Code
            </Button>
                        <Button
              variant="contained"
              color="secondary"
              sx={{
                ml: 2,
                fontWeight: 'bold',
                borderRadius: '20px',
                backgroundColor: '#ffffff', // warm accent tone like orange or gold
                color: 'black',
                '&:hover': {
                  backgroundColor: '#fb8c00',
                },
              }}
              component={Link}
              to="/ugly-house"
            >
              Ugly House Contest
            </Button>
            <Button color="inherit" onClick={handleVideoOpen}>About</Button>
            <Button color="inherit" onClick={() => setContactOpen(true)}>Contact</Button>
            {/*<IconButton color="inherit" onClick={toggleTheme}>
              {isDarkMode ? <Brightness7 /> : <Brightness4 />}
            </IconButton>*/}
            <Button color="inherit" onClick={() => setSignInOpen(true)}>Sign In</Button>
          </Box>
        </Toolbar>
      </AppBar>

      {/* Mobile Drawer */}
      <Drawer anchor="left" open={mobileOpen} onClose={handleDrawerToggle}>
        <List>
          <ListItem button onClick={handleDrawerToggle}>
            <ListItemText primary="Open House Entry Code" />
          </ListItem>
          <ListItem button onClick={handleDrawerToggle}>
            <ListItemText primary="Ugly House Contest" />
          </ListItem>
          <ListItem button onClick={handleVideoOpen}>
            <ListItemText primary="About" />
          </ListItem>
          <ListItem button onClick={() => setContactOpen(true)}>
            <ListItemText primary="Contact" />
          </ListItem>
          <ListItem button onClick={() => setSignInOpen(true)}>
            <ListItemText primary="Sign In" />
          </ListItem>
        </List>
      </Drawer>

      {/* Modal for Video */}
      <Dialog open={videoOpen} onClose={handleVideoClose} fullWidth maxWidth="xl">
        <Box sx={{ p: 2, textAlign: "center" }}>
          <Typography variant="h6" gutterBottom>
            About Rocket Offer
          </Typography>

          <Box
            sx={{
              position: "relative",
              paddingBottom: "56.25%", // 16:9 aspect ratio
              height: 0,
              overflow: "hidden",
            }}
          >
            <iframe
              src="https://www.youtube.com/embed/kqu8qrw56Kk"
              title="Rocket Offer Video"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              frameBorder="0"
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
              }}
            />
          </Box>

          <Button
            onClick={handleVideoClose}
            sx={{ mt: 2 }}
            variant="contained"
            color="primary"
          >
            Close
          </Button>
        </Box>
      </Dialog>


      {/* Pop-up (Dialog) containing Contact.js */}
      <Dialog open={contactOpen} onClose={() => setContactOpen(false)} fullWidth maxWidth="sm">
        <DialogTitle>Contact Us</DialogTitle>
        <DialogContent>
          <Contact />  {/* Render the Contact component inside the pop-up */}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setContactOpen(false)}>Close</Button>
        </DialogActions>
      </Dialog>

      {/* Pop-up (Dialog) containing Login.js */}
      <Dialog open={signInOpen} onClose={() => setSignInOpen(false)} fullWidth maxWidth="sm">
        <DialogTitle>Rocket Offer</DialogTitle>
        <DialogContent>
          <Login />  {/* Render the Login component inside the pop-up */}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setSignInOpen(false)}>Close</Button>
        </DialogActions>
      </Dialog>

    </>
  );
};

export default Header;